import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0df3bf91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-inline-block" }
const _hoisted_2 = { class: "filter-phrase" }

import { computed } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterButton',
  props: {
  filterCount: {
    type: Number,
    default: 0
  }
},
  emits: ["click-filter"],
  setup(__props, { emit: emits }) {

const props = __props;



const isFilterApplied = computed(() => {
  return props.filterCount > 0;
});

const btnClass = computed(() => {
  if (isFilterApplied.value) {
    return "filter-button--applied";
  }
  return "";
});



function onClickFilter() {
  emits("click-filter");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["filter-button", btnClass.value]),
      onClick: onClickFilter
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(FeatherIcon, { icon: "filter" }),
        _createTextVNode(" " + _toDisplayString(isFilterApplied.value ? "絞り込み中" : "絞り込み"), 1)
      ])
    ], 2)
  ]))
}
}

})